module.exports = __webpack_public_path__ + "static/media/pizza-removebg-preview.50456335.png";